var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinanzasRegenerativas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6517 7.00002H16.8617L12.4817 0.44002C12.2917 0.16002 11.9717 0.0200195 11.6517 0.0200195C11.3317 0.0200195 11.0117 0.16002 10.8217 0.45002L6.44167 7.00002H1.65167C1.10167 7.00002 0.651672 7.45002 0.651672 8.00002C0.651672 8.09002 0.661672 8.18002 0.691672 8.27002L3.23167 17.54C3.46167 18.38 4.23167 19 5.15167 19H18.1517C19.0717 19 19.8417 18.38 20.0817 17.54L22.6217 8.27002L22.6517 8.00002C22.6517 7.45002 22.2017 7.00002 21.6517 7.00002ZM11.6517 2.80002L14.4517 7.00002H8.85167L11.6517 2.80002ZM18.1517 17L5.16167 17.01L2.96167 9.00002H20.3517L18.1517 17ZM11.6517 11C10.5517 11 9.65167 11.9 9.65167 13C9.65167 14.1 10.5517 15 11.6517 15C12.7517 15 13.6517 14.1 13.6517 13C13.6517 11.9 12.7517 11 11.6517 11Z",
    fill: "#01B574"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanzasRegenerativas);
export default __webpack_public_path__ + "static/media/finanzas-regenerativas.124c5a01965bc4a71f82e01d3bc2959b.svg";
export { ForwardRef as ReactComponent };